import React from 'react';
import { Card, Btn, Divider, Header, BottomNav, CheckIcon, InfoIcon } from '../components/SharedComponents';
import C from '../styles/tokens';

const WithdrawalSubmitted = ({ navigate }) => (
  <div className="page-wrapper slide-up">
    <Header title="Withdrawal Submitted" onBack={() => navigate('dashboard')} />

    <div className="page-content-lg">

      {/* Success Icon */}
      <div className="text-center mb-24">
        <div className="success-icon-wrap success-icon-wrap-green" style={{ margin: '0 auto 14px' }}>
          <CheckIcon color={C.accent} size={32} strokeWidth={2.5} />
        </div>
        <h2 style={{ fontWeight: 900, fontSize: 22, color: C.textPrimary }}>
          Withdrawal Submitted!
        </h2>
        <p style={{ color: C.textSecondary, fontSize: 14, marginTop: 6, lineHeight: 1.5 }}>
          Your withdrawal request has been received and is now being processed.
        </p>
      </div>

      {/* Details Card */}
      <Card style={{ marginBottom: 16 }}>
        {[
          { label: 'Amount Withdrawn',   val: '100 USDT' },
          { label: 'Network',            val: 'TRC20' },
          { label: 'Receiving Address',  val: 'TFh6tJyVtrq935Bn...', mono: true },
          { label: 'Est. Confirmation',  val: '5–10 minutes' },
        ].map((row, i) => (
          <div key={i}>
            {i > 0 && <Divider />}
            <div className="flex justify-between items-center gap-10" style={{ padding: '10px 0' }}>
              <span style={{ fontSize: 13, color: C.textMuted, flexShrink: 0 }}>{row.label}</span>
              <span style={{
                fontWeight: 700, fontSize: 13,
                color: C.textPrimary,
                fontFamily: row.mono ? 'Space Mono, monospace' : 'Nunito, sans-serif',
                textAlign: 'right', wordBreak: 'break-all',
              }}>
                {row.val}
              </span>
            </div>
          </div>
        ))}
      </Card>

      {/* Info Note */}
      <div className="alert-info">
        <InfoIcon color={C.primary} />
        <div style={{ fontSize: 13, color: C.textSecondary }}>
          Average confirmation time: <strong>5–10 minutes</strong>. Contact us if funds
          are not credited within 30 minutes.
        </div>
      </div>

      {/* Actions */}
      <Btn onClick={() => navigate('withdrawalStatus')} variant="primary" full size="lg">
        View Withdrawal Status
      </Btn>
      <Btn
        onClick={() => navigate('dashboard')}
        variant="ghost" full size="md"
        style={{ marginTop: 10 }}
      >
        Back to Dashboard
      </Btn>
    </div>

    <BottomNav active="withdraw" navigate={navigate} />
  </div>
);

export default WithdrawalSubmitted;
